module.exports = __webpack_public_path__ + "static/media/trainings_1000.e0db3e5f.png";